/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedOrganizationListListResponse } from '../types/PaginatedOrganizationListList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type OrganizationsListRequest = {} | null | undefined;
export type OrganizationsListResponse = PaginatedOrganizationListListResponse;

export type OrganizationsListQuery = {
  /**
   * ```yaml
   * in: query
   * name: dic__icontains
   * schema:
   *   type: string
   * ```
   */
  dic__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: for_manager_app
   * schema:
   *   type: boolean
   * ```
   */
  for_manager_app?: boolean;

  /**
   * ```yaml
   * in: query
   * name: ico__icontains
   * schema:
   *   type: string
   * ```
   */
  ico__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;

  /**
   * ```yaml
   * name: search
   * required: false
   * in: query
   * description: A search term.
   * schema:
   *   type: string
   * ```
   */
  search?: string;
};

/**
 * GET /dmx-server/organizations/
 *
 * ```yaml
 * operationId: organizations_list
 * tags:
 *   - organizations
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedOrganizationListList'
 *     description: ''
 * ```
 */
export const organizationsListOperation = (rest?: OrganizationsListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/organizations/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/organizations/' };
  };

/**
 * GET /dmx-server/organizations/
 *
 * ```yaml
 * operationId: organizations_list
 * tags:
 *   - organizations
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedOrganizationListList'
 *     description: ''
 * ```
 */
export const organizationsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: OrganizationsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedOrganizationListListResponse>> => {
  const operation = organizationsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/organizations/
 */
export const useOrganizationsListResource = (
  query: OrganizationsListQuery | null,
  useCached?: boolean,
): UseResource<OrganizationsListResponse> => {
  return useResource<OrganizationsListResponse>({
    path: query === null ? null : organizationsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
